import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { AbsoluteRoute } from "../absoluteRoutes";

export const useAppGlobalRoutes = (): {
    goToAccessDenied: () => void;
    goToNoRoleAssigned: () => void;
} => {
    const navigate = useNavigate();
    const goToAccessDenied = useCallback(() => {
        navigate(AbsoluteRoute.ACCESS_DENIED);
    }, [navigate]);
    const goToNoRoleAssigned = useCallback(() => {
        navigate(AbsoluteRoute.NO_ROLE_ASSIGNED);
    }, [navigate]);

    return {
        goToAccessDenied,
        goToNoRoleAssigned,
    };
};
